import script from "./StockManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./StockManagement.vue?vue&type=script&setup=true&lang=js"

import "./StockManagement.vue?vue&type=style&index=0&id=fee2cbf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fee2cbf2"]])

export default __exports__